import Query from '../../../components/Report';

const query = (entity_name) => new Query('discover-connected-entities-single', { entity_name });

export default query;
